import CheckboxField from 'components/Fields/Checkbox/Checkbox';
import React, { useState, useEffect } from 'react';

type ReportSectionProps = {
  data: any;
  selectItem: Function;
  index: number;
};

const ReportSection: React.FC<ReportSectionProps> = ({
  data,
  selectItem,
  index
}) => {
  const [value, setValue] = useState(false);

  useEffect(() => {
    setValue(data.isSelected || false);
  }, [data.isSelected]);

  return (
    <>
      <div>{data.name}</div>
      <CheckboxField
        meta={{ touched: false, invalid: false, error: false }}
        fullWidth={false}
        input={{
          value: value,
          onChange: () => {
            setValue(!value);
            selectItem(index);
          },
          checked: value
        }}
      />
    </>
  );
};

export default ReportSection;
